import type { FC } from "react"
import { useCallback, memo } from "react"
import { useCreation } from "ahooks-v2"
import { PolygonLayer } from "@wayz/react-gl"
import { polygon, featureCollection } from "@turf/turf"
import { colorToRGBArray } from "@/util/util"

interface geographicRangeArgs {
  id?: string
  visible?: boolean
  data: {
    id: string
    aoiPolygon: number[][]
    color?: string // 线框颜色
  }[]
  strokeWidth?: number
  activeId?: string // 激活对象的id
  zIndex?: number
  color?: string
  onClick?: (id: string) => void
}
const GeographicRange: FC<geographicRangeArgs> = ({
  id = "polygon",
  data = [],
  strokeWidth = 1,
  visible = false,
  zIndex,
  color,
  onClick,
}) => {
  const allGroup = useCreation(() => {
    const polygonList = []
    for (const item of data) {
      if (item?.aoiPolygon?.length) {
        polygonList.push(
          polygon([item.aoiPolygon], {
            id: item.id,
            color: item.color,
          }),
        )
      }
    }
    return featureCollection(polygonList)
  }, [data])

  // 点击Polygon图层
  const handleClick = useCallback(
    ({ object }) => {
      const { id } = object.properties
      onClick && onClick(id)
    },
    [onClick],
  )

  return (
    <PolygonLayer
      id={id}
      visible={visible}
      pickable={true}
      stroked={true}
      data={allGroup.features || []}
      getPolygon={(f: any) => f.geometry.coordinates}
      getFillColor={
        color ? colorToRGBArray(color, 0.05) : (f: any) => colorToRGBArray(f.properties.color, 0.05)
      }
      getLineWidth={strokeWidth}
      lineWidthUnits="pixels"
      getLineColor={
        color ? colorToRGBArray(color, 0.7) : (f: any) => colorToRGBArray(f.properties.color, 0.7)
      }
      autoHighlight={true}
      highlightColor={
        color
          ? colorToRGBArray(color, 0.1)
          : (info) => {
              const color = info?.object.properties.color
              return colorToRGBArray(color ?? "#BEFF42", 0.1)
            }
      }
      zIndex={zIndex}
      onClick={handleClick}
    />
  )
}
export default memo(GeographicRange)
